import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addAlert, selectLoading } from "modules/notification";
import { sendResetPasswordLink } from "modules/trackco/redux";
import ForgotPasswordPage from "./forgot-password.page";
import { getLang } from "app/feature/constants";

function ForgotPasswordContainer() {
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [email, setEmail] = useState("");
  const [counter, setCounter] = useState(60);
  const dispatch = useDispatch();
  const invitationCode = useSelector(
    (state) => state.trackco.profile.invitationCode
  );
  const lang = useSelector((state) => state.constant.languages);
  const isSendingResetPasswordLink = useSelector((state) =>
    selectLoading(state, sendResetPasswordLink.typePrefix)
  );

  useEffect(() => {
    if (counter > 0 && isEmailSent) {
      const timer = setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, isEmailSent]);

  const handleSentResetPasswordLink = async (values) => {
    const result = await dispatch(
      sendResetPasswordLink({ email: values.email })
    );

    if (
      sendResetPasswordLink.fulfilled.match(result) &&
      result.payload.success
    ) {
      // Only proceed to success state if API actually succeeded
      setIsEmailSent(true);
      setEmail(values.email);
    } else {
      // Handle API errors - check for specific error codes
      const errorCode = result.payload?.code || result.error?.code;
      if (errorCode === "ERROR_INVALID_EMAIL") {
        dispatch(
          addAlert({
            severity: "error",
            message:
              getLang(lang, "message.error.INVALID_EMAIL") ||
              "Please enter a valid email address",
          })
        );
      } else {
        dispatch(
          addAlert({
            severity: "error",
            message:
              getLang(lang, "message.error.FAIL_SENT_RESET_PASSWORD_LINK") ||
              "Failed to send reset password link",
          })
        );
      }
    }
  };

  const handleResendResentPasswordLink = async () => {
    const result = await dispatch(sendResetPasswordLink({ email: email }));

    if (
      sendResetPasswordLink.fulfilled.match(result) &&
      result.payload.success
    ) {
      // Only reset counter if API actually succeeded
      setCounter(60);
    } else {
      // Handle API errors - check for specific error codes
      const errorCode = result.payload?.code || result.error?.code;
      if (errorCode === "ERROR_INVALID_EMAIL") {
        dispatch(
          addAlert({
            severity: "error",
            message:
              getLang(lang, "error.ERROR_INVALID_EMAIL") ||
              "Please enter a valid email address",
          })
        );
      }
    }
  };

  return (
    <ForgotPasswordPage
      handleSubmit={handleSentResetPasswordLink}
      isEmailSent={isEmailSent}
      isSendingResetPasswordLink={isSendingResetPasswordLink}
      email={email}
      counter={counter}
      enableResent={counter === 0}
      handleResendPassword={handleResendResentPasswordLink}
      invitationCode={invitationCode}
      lang={lang}
    />
  );
}

export default ForgotPasswordContainer;
